<script setup>
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import useCartStore from "../../store/modules/cart";
import IModal from "../IModal/IModal.vue";
import { computed, ref } from "vue";

translator.getLanguages();

const cartStore = useCartStore();
const showModal = ref(false);

const props = defineProps({
	count: {
		type: Number,
		default: 1,
	},
	item: {
		type: Object,
		default: null,
	},
	order: {
		type: Object,
		default: null,
	},
});
const emits = defineEmits(["click"]);
const isContainsReturnedTickets = computed(() => String(props.order?.statusId)[0] >= 4);
const eventIsReturned = computed(() =>
	props.item?.tickets.some(element => element.isRefunded === true)
);

function clickHandler() {
	if (!props.item) {
		emits("click");
	} else if (!eventIsReturned.value) {
		showModal.value = true;
	} else {
		cartStore.refundTickets(props.item.orderId, props.item.id);
	}
}
</script>

<template>
	<div
		class="i-refund"
		:class="{ red: isContainsReturnedTickets || eventIsReturned }"
		@click="clickHandler()"
	>
		<svg class="icon icon_eclipse">
			<use xlink:href="#ticket-return"></use>
		</svg>
		<template v-if="isContainsReturnedTickets || eventIsReturned">
			{{ translator.t("main", "Return issued") }}
		</template>
		<template v-else>
			{{ translator.t("main", "Return of tickets") }}
		</template>
		<span v-if="count > 1">({{ count }})</span>
	</div>
	<IModal
	v-model="showModal"
	:btn-primary="'Да'"
	:btn-secondary="'Нет'"
	@ok="cartStore.refundTickets(props.item.orderId, props.item.id)"
	>
	<template #body>
		<p class="mb-2">
			{{ translator.t("main", "Are you sure you want to return the tickets and issue a refund?") }}
		</p>
		{{ translator.t("main", "After confirmation, it will be impossible to cancel the return!") }}
		</template>
	</IModal>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-refund.scss";
</style>
